const functionRouteMap = {
  Orders: "order",
  "Goods receipts": "grn",
  Invoices: "invoice",
};

export default functionRouteMap;
